import { PaymentHistoryItemDto } from '../../../models/dtos/payment-history-item.dto';

/**
 * Payment history DTOs (as they come from the API) for testing
 */

export const mockLoanIds = ['1001', '1002'];

export const mockPaymentHistoryDtos: Record<string, PaymentHistoryItemDto[]> = {
  [mockLoanIds[0]]: [
    {
      date_paid: '2025-05-08T00:00:00.000Z',
      due_date: '2025-05-01T00:00:00.000Z',
      payment_number: 1,
      payment_description: 'Regular Payment',
      payment_amount: 1200.00,
      transaction_code: 101,
      transaction_reference_no: 987654
    },
    {
      date_paid: '2025-04-08T00:00:00.000Z',
      due_date: '2025-04-01T00:00:00.000Z',
      payment_number: 2,
      payment_description: 'NSF Payment',
      payment_amount: 1200.00,
      transaction_code: 102,
      transaction_reference_no: 987655
    }
  ],
  [mockLoanIds[1]]: [
    {
      date_paid: '2025-05-08T00:00:00.000Z',
      due_date: '2025-05-01T00:00:00.000Z',
      payment_number: 1,
      payment_description: 'Regular Payment',
      payment_amount: 450.00,
      transaction_code: 103,
      transaction_reference_no: 987656
    },
    {
      date_paid: '2025-04-08T00:00:00.000Z',
      due_date: '2025-04-01T00:00:00.000Z',
      payment_number: 2,
      payment_description: 'Regular Payment',
      payment_amount: 450.00,
      transaction_code: 104,
      transaction_reference_no: 987657
    }
  ]
};
